module.exports = __webpack_public_path__ + "img/PPMP24.e6eb9adf.png";